import React from 'react';

function Header(){
    return(
        <header style = {styles.headerContainer}>
            <div style ={styles.profileContainer}>
            <img
                src={require("./Pictures & pdfs\\closeUp 24th birthday.png")}
                alt=""
                className = "headshot"
                style={styles.profileImage}
            />
            <div style={styles.textContainer}>
                <h1 style={styles.name}>George Blue</h1>
                <p style = {styles.description}>
                    Software Engineer | Rock Climber | Nature Enthusiast
                </p>
                <div style={styles.socialLinks}>
                    <a href="https://www.linkedin.com/in/george-blue/" target="_blank" rel="noopener noreferrer" style ={styles.icon}>
                        <i className="fab fa-linkedin fa-2x"></i> {/* FontAwesome Linkedin */} 
                    </a>
                </div>
            </div>
            </div>
        </header>
    );
}

const styles = 
{
    
    headerContainer: {
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
        padding: "20px",
    },
    profileContainer: {
        display: "flex",
        alignItems: "center",
        gap: "20px"
    },
    profileImage: {
        width: "250px",
        height: "250px",
        borderRadius: "50%",
        objectFit: "cover",
        boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    name: {
        margin: "5px 0",
        fontsize: "16px",
        color: "rgb(218, 213, 213)",
    },
    description: {
        margin: "5px 0",
        fontSize: "16px",
        color: "rgb(218, 213, 213)",
    },
    socialLinks: {
        display: "flex",
        gap: "10px",
        marginTop: "10px",
    },
    icon: {
        display: "inline-block",
        fontsize: "30",
        color: "#0077b5",
        textDecoration: "none",
        transition: "color 0.3s",
    },
};

export default Header;